import { Navigate } from "react-router-dom";
import { useSplatBasePath } from "./useSplatBasePath";

export interface SplatRedirectProps {
  /** Path segment(s) to redirect to, relative to the splat route's parent. */
  to: string;
}

/**
 * Drop-in replacement for a relative `<Navigate to="x" />` rendered inside a
 * `path: "*"` catch-all route.
 *
 * Redirects to an absolute `${splatParent}/${to}`, so it cannot append to the
 * matched splat and loop under react-router v7. Mount-agnostic — it derives the
 * parent path at runtime, so the same component works wherever the route tree
 * is mounted. See {@link useSplatBasePath} for the underlying mechanism.
 *
 * There is intentionally no `replace` prop: a catch-all redirect should always
 * replace the history entry rather than push a dead URL onto the stack.
 */
export const SplatRedirect = ({ to }: SplatRedirectProps) => {
  const base = useSplatBasePath();
  return <Navigate replace to={`${base}/${to}`} />;
};
